import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos'
import Lock from '@mui/icons-material/Lock'
import { useContext, useMemo, useRef, useState } from 'react'
import { TILE_CARD_VIEW_TYPES } from 'src/consumer/constants'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import TileV2Header from '../TileV2Header'
import {
  SpreadBoardActualDetailsContainer,
  SpreadBoardBackFilterBackground,
  SpreadBoardBoxBorder,
  SpreadBoardBoxDetailsContainer,
  SpreadBoardCardContainer,
  SpreadBoardContentContainer,
  SpreadBoardDetailsButton,
  SpreadBoardDetailsLandScapeContainer,
  SpreadBoardDetailsPortraitContainer,
  SpreadBoardDetailsSubtitle,
  SpreadBoardDetailsTitle,
  SpreadBoardHeading,
  SpreadBoardLockedItemOverlay,
  SpreadBoardMultiPartContainer,
  SpreadBoardParentItemBackground,
  SpreadBoardSecondaryItemDetails,
  SpreadBoardSecondaryItemsContainer,
  SpreadBoardSecondarySingleItemContainer,
  SpreadBoardShowAllHeadingContainerForPositioning,
  SpreadBoardSubHeading,
  SpreadBoardTertiaryHeading,
  SpreadSecondaryItemBackground,
} from './spreadBoardStyledComponents'

export default function SpreadBoardCard({
  headingLogicAndData,
  areTileItemsHovered,
  logicAndData,
}) {
  console.log({ logicAndData })
  return (
    <>
      <SpreadBoardCardContainer>
        <SpreadBoardItemList {...logicAndData} headingLogicAndData={headingLogicAndData} />
      </SpreadBoardCardContainer>
    </>
  )
}

function SpreadBoardItemList({ items, ...rest }) {
  const { setupData } = useContext(SetupContext)

  const isMobile = useMemo(() => {
    if (setupData?.clientType === 'desktopBrowser') {
      return false
    } else {
      return true
    }
  }, [setupData])

  return items?.map((item, index) => (
    <SpreadBoardSingleParentItem key={index} {...rest} item={item} isMobile={isMobile} />
  ))
}

function SpreadBoardSingleParentItem({
  item,
  getTitleField,
  getSecondaryText,
  getMainImage,
  getActionButtonLogic,
  isMobile,
  headingLogicAndData,
  ...rest
}) {
  const refToContainer = useRef()
  const [isHovered, setIsHovered] = useState(false)
  const secondaryItems = rest?.getSecondaryItems ? rest.getSecondaryItems(item) : []

  return (
    <SpreadBoardMultiPartContainer
      ref={refToContainer}
      onMouseEnter={() => {
        setIsHovered(true)
      }}
      onMouseLeave={() => {
        setIsHovered(false)
      }}
      isMobile={isMobile}
    >
      <SpreadBoardParentItemBackground src={getImageLink(getMainImage(item))} />
      <SpreadBoardContentContainer isMobile={isMobile}>
        {!isMobile ? (
          <>
            <SpreadBoardDetailsLandScapeContainer isHovered={isHovered}>
              {getTitleField && (
                <SpreadBoardDetailsTitle>{getTitleField(item)}</SpreadBoardDetailsTitle>
              )}
              {getSecondaryText && (
                <SpreadBoardDetailsSubtitle>{getSecondaryText(item)}</SpreadBoardDetailsSubtitle>
              )}
              {getActionButtonLogic && (
                <SpreadBoardDetailsButton onClick={() => getActionButtonLogic(item)?.onClick(item)}>
                  {getActionButtonLogic(item)?.text}
                  <ArrowForwardIos sx={{ fontSize: 25, color: 'white' }} />
                </SpreadBoardDetailsButton>
              )}
            </SpreadBoardDetailsLandScapeContainer>
            <SpreadBoardShowAllHeadingContainerForPositioning isHovered={isHovered}>
              <TileV2Header
                logicAndData={{
                  ...headingLogicAndData,
                  isOnBackground: headingLogicAndData?.isOnBackground,
                  currentSecondaryItem: item,
                }}
              />
            </SpreadBoardShowAllHeadingContainerForPositioning>
          </>
        ) : (
          <SpreadBoardDetailsPortraitContainer>
            <SpreadBoardDetailsTitle isMobile={isMobile}>
              {getTitleField(item)}
            </SpreadBoardDetailsTitle>
            <SpreadBoardDetailsSubtitle isMobile={isMobile}>
              {getSecondaryText(item)}
            </SpreadBoardDetailsSubtitle>
            {/* <DetailsButton>
                            Start with the Series
                            <ArrowForwardIosIcon sx={{ fontSize: 25, color: 'white' }} />
                        </DetailsButton> */}
          </SpreadBoardDetailsPortraitContainer>
        )}

        <SpreadBoardSecondaryItemsContainer isHovered={isHovered} isMobile={isMobile}>
          {secondaryItems?.map((sItem, index) => {
            return (
              <SpreadBoardViewsWrapper
                key={index}
                {...rest}
                sItem={sItem}
                sbIndex={index}
                isHovered={isHovered}
                isMobile={isMobile}
                parentItem={item}
              />
            )
          })}
        </SpreadBoardSecondaryItemsContainer>
      </SpreadBoardContentContainer>
    </SpreadBoardMultiPartContainer>
  )
}

function SpreadBoardViewsWrapper({ sItem, ...props }) {
  // console.log({ props, getSecondaryItemViewType: props?.getSecondaryItemViewType })
  const viewType = props?.getSecondaryItemViewType(sItem) || TILE_CARD_VIEW_TYPES.default

  const SpreadBoardComponentToUse =
    SpreadBoardViewStates?.[viewType] || SpreadBoardSingleSecondaryItemBase

  return <SpreadBoardComponentToUse {...props} item={sItem} />
}

export function SpreadBoardSingleSecondaryItemLocked({ ...props }) {
  const { sbIndex, getBoxedMainTitleText, getBoxedMainTitleSubText, parentItem, ...rest } = props
  return (
    <SpreadBoardSingleSecondaryItemBase
      {...rest}
      getSecondaryItemTitle={null}
      secondaryItemOnClick={null}
      getSecondaryItemSecondaryText={null}
      sbIndex={sbIndex}
    >
      <SpreadBoardLockedItemOverlay>
        {(getBoxedMainTitleText || getBoxedMainTitleSubText) && (
          <SpreadBoardBoxDetailsContainer style={{ height: 'unset' }}>
            <SpreadBoardBoxBorder>
              {getBoxedMainTitleText && (
                <SpreadBoardHeading style={{ minHeight: 0 }}>
                  {getBoxedMainTitleText(parentItem, sbIndex)}
                </SpreadBoardHeading>
              )}
              {getBoxedMainTitleSubText && (
                <SpreadBoardSubHeading style={{ minHeight: 0 }}>
                  {getBoxedMainTitleSubText(parentItem, sbIndex)}
                </SpreadBoardSubHeading>
              )}
            </SpreadBoardBoxBorder>
          </SpreadBoardBoxDetailsContainer>
        )}
        <Lock />
      </SpreadBoardLockedItemOverlay>
    </SpreadBoardSingleSecondaryItemBase>
  )
}

export function SpreadBoardSingleSecondaryItemBase({
  sbIndex,
  isMobile,
  isHovered,
  getPreselected = (item, sbIndex) => {
    return sbIndex === 0
  },
  secondaryItemOnClick,
  getSecondaryItemImage,
  getSecondaryItemTitle,
  getSecondaryItemSecondaryText,
  getSecondaryItemViewType,
  getTertiaryTitle,
  getBoxedMainTitleText,
  getBoxedMainTitleSubText,
  item,
  parentItem,
  children,
}) {
  const isPreselected = getPreselected(item, sbIndex)
  const handleSecondaryOnClick = secondaryItemOnClick
    ? () => secondaryItemOnClick(parentItem, item, sbIndex)
    : null

  return (
    <SpreadBoardSecondarySingleItemContainer
      preselected={isPreselected}
      isHovered={isHovered}
      isMobile={isMobile}
      nopointer={!secondaryItemOnClick}
      onClick={handleSecondaryOnClick}
    >
      <SpreadSecondaryItemBackground
        src={getImageLink(
          getSecondaryItemImage ? getSecondaryItemImage(parentItem, item, sbIndex) : null,
        )}
      />
      <SpreadBoardBackFilterBackground />
      <SpreadBoardSecondaryItemDetails>
        {(getBoxedMainTitleText || getBoxedMainTitleSubText) && (
          <SpreadBoardBoxDetailsContainer>
            <SpreadBoardBoxBorder>
              {getBoxedMainTitleText && (
                <SpreadBoardHeading style={{ minHeight: 0 }}>
                  {getBoxedMainTitleText(parentItem, sbIndex)}
                </SpreadBoardHeading>
              )}
              {getBoxedMainTitleSubText && (
                <SpreadBoardSubHeading style={{ minHeight: 0 }}>
                  {getBoxedMainTitleSubText(parentItem, sbIndex)}
                </SpreadBoardSubHeading>
              )}
            </SpreadBoardBoxBorder>
          </SpreadBoardBoxDetailsContainer>
        )}
        <SpreadBoardActualDetailsContainer>
          {getTertiaryTitle && getTertiaryTitle(parentItem, item, sbIndex) && (
            <SpreadBoardTertiaryHeading>
              {getTertiaryTitle(parentItem, item, sbIndex)}
            </SpreadBoardTertiaryHeading>
          )}
          {getSecondaryItemTitle && (
            <SpreadBoardHeading>
              {getSecondaryItemTitle(parentItem, item, sbIndex)}
            </SpreadBoardHeading>
          )}

          {getSecondaryItemSecondaryText && (
            <SpreadBoardSubHeading>
              {getSecondaryItemSecondaryText(parentItem, item, sbIndex)}
            </SpreadBoardSubHeading>
          )}
        </SpreadBoardActualDetailsContainer>
      </SpreadBoardSecondaryItemDetails>

      {children}
    </SpreadBoardSecondarySingleItemContainer>
  )
}

const SpreadBoardViewStates = {
  [TILE_CARD_VIEW_TYPES.default]: SpreadBoardSingleSecondaryItemBase,
  [TILE_CARD_VIEW_TYPES.locked]: SpreadBoardSingleSecondaryItemLocked,
}
